import * as React from 'react';
import { Context, useContext } from 'react';

export type SidebarMenuContextProps = {
  pathname: string;
  navigationRootPath: string;
  openMenuItems: string[];
  toggleOpenMenuItems: (path: string) => void;
};

export const SidebarMenuContext: Context<SidebarMenuContextProps> =
  React.createContext({
    pathname: '',
    navigationRootPath: '',
    openMenuItems: [] as string[],
    toggleOpenMenuItems: (path: string) => {},
  });

export const useSidebarMenuContext = (): SidebarMenuContextProps => {
  return useContext<SidebarMenuContextProps>(SidebarMenuContext);
};
